module.exports = __webpack_public_path__ + "static/media/q_nav_6_selected.be56a47e.svg";